import { createSlice } from '@reduxjs/toolkit';

const storedSeller = localStorage.getItem('seller');
const storedToken = localStorage.getItem('token');

const initialState = {
  seller: storedSeller ? JSON.parse(storedSeller) : null,
  token: storedToken || null,
  isAuthenticated: !!storedToken,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => { state.loading = true; state.error = null; },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.seller = action.payload.seller;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('seller', JSON.stringify(action.payload.seller));
    },
    loginFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    logout: (state) => {
      state.seller = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem('token');
      localStorage.removeItem('seller');
      localStorage.clear();
      sessionStorage.clear();
    },
    updateSellerProfile: (state, action) => {
      state.seller = { ...state.seller, ...action.payload };
      localStorage.setItem('seller', JSON.stringify(state.seller));
    },
    clearError: (state) => { state.error = null; },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, updateSellerProfile, clearError } = authSlice.actions;
export default authSlice.reducer;
